import * as React from "react";
import { useGetStatuses } from "security-app/hooks/useInvestigationsAPI";
import { Spinner } from "components/common";
const StatusValue = ({ statusName }) => {
  const { statuses, loadingStatuses } = useGetStatuses();
  if (loadingStatuses) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const status = statuses.find(({ status: statName }) => statusName === statName);
  if (status) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, status.status);
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, "unknown");
};
export default StatusValue;
